define('LoyalityLandingForm.View'
,	[
		'tavanoteam_loyalitylandingform_loyalitylandingform.tpl'
	,	'Backbone.FormView'	
	,	'Backbone.CompositeView'
	,	'TavanoTeam.LoyalityLandingForm.Model'	
	,	'Backbone.CollectionView'
	,	'SC.Configuration'
	,	'Loyality.Confirmation.View'
	,	'Utils'
	,	'jQuery'
	,	'underscore'
	]
,	function (
	tavanoteam_loyalitylandingform_loyalitylandingform
	,	BackboneFormView
	,	BackboneCompositeView	
	,	LoyalityFormModel
	,	BackboneCollectionView	
	,	Configuration
	,	LoyalityConfirmationView
	,	Utils
	,	jQuery
	,	_
	)
{
	'use strict';

	return Backbone.View.extend({

		template: tavanoteam_loyalitylandingform_loyalitylandingform
		,	
	
		initialize: function (options) {
			BackboneCompositeView.add(this);
			this.model = new LoyalityFormModel();
			var self = this;
			this.application = options.application;

			this.model.fetch({
				data: { id: 204 }
			})
			.done(function(response) {
				self.render();
			});
			BackboneFormView.add(this);
			this.model.on('save', jQuery.proxy(this, 'manageResponse'));
		},
		bindings: {
			'[name="firstname"]': 'firstname'
			,	'[name="lastname"]': 'lastname'
			,	'[name="email"]': 'email'
			,	'[name="help"]': 'help'
			,	'[name="city"]': 'city'
			,	'[name="company"]': 'company'
			,	'[name="zip"]': 'zip'
			,	'[name="phone"]': 'phone'	
			,	'[name="industry"]': 'industry'	
			,	'[name="roles"]': 'roles'	
			,	'[name="interest"]': 'interest'	
			,	'[name="state"]': 'state'	

		},

		events: {
			'submit form': 'saveForm'
		},

		getContext: function getContext()
		{
			var self = this;
			var marketingRoles = this.defineValues(self.model.attributes.marketingRoles);
			var industry = this.defineValues(self.model.attributes.industry);
			var interest = this.defineValues(self.model.attributes.interest);
			var states = this.defineValues(SC.ENVIRONMENT.siteSettings.countries["US"].states, true);
			
			return {
				tellUsSelectValues: marketingRoles,
				industrySelectValues: industry,
				interestSelectValues: interest,
				states: states
			};
		},
		manageResponse : function showSuccess(model) {
			if (model.get("status") == 500)
				this.showWarningMessage(this.errorMessage + _(model.get('code')).translate() , true);
			else
				 this.showSuccess()
		},
		showSuccess : function showSuccess() {
			var layout = this.application.getLayout();
			var loyalityConfView = new LoyalityConfirmationView({});
			layout.showInModal(loyalityConfView,{});
		},
		
		defineValues: function defineValues(list, isState){
			var ret = [];
			if(!isState){
				_.each(list,function(element, i){
					var elementInfo = {
						internalId: element.valueid,
						isActive: false,
						label: element.value
					}
					ret.push(elementInfo);
				})
			}else{
				_.each(list,function(element, i){
					var elementInfo = {
						internalId: element.code,
						isActive: false,
						label: element.name
					}
					ret.push(elementInfo);
				})
			}
			
			return ret;
		}
	});
});
